function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../../../_snowpack/pkg/react.js';
import { useSelect } from '../../../../_snowpack/pkg/downshift.js';
import styled from '../../../../_snowpack/pkg/styled-components.js';
import classNames from '../../../../_snowpack/pkg/classnames.js';
const ITEMS = [{
  identifier: `Developer`,
  label: `Build my own e-commerce project`
}, {
  identifier: `Developer`,
  label: `Evaluate your GraphQL API's`
}, {
  identifier: `Marketeer`,
  label: `Organize and activate my team's product content`
}, {
  identifier: `Agency`,
  label: `Test your headless e-commerce solution for a client`
}, {
  identifier: `Agency`,
  label: `Test your PIM/DAM solution for a client`
}, {
  identifier: `Business`,
  label: `Evaluate your toolset for a future migration`
}];

function TagSelect(props) {
  const {
    onSelect
  } = props;
  const {
    isOpen,
    selectedItem,
    getToggleButtonProps,
    getMenuProps,
    highlightedIndex,
    getItemProps
  } = useSelect({
    id: 'user-tag',
    items: ITEMS,
    circularNavigation: true,
    onSelectedItemChange: ({
      selectedItem
    }) => {
      selectedItem && onSelect(selectedItem.identifier);
    },
    itemToString: item => {
      var _item$label;

      return (_item$label = item === null || item === void 0 ? void 0 : item.label) !== null && _item$label !== void 0 ? _item$label : '';
    }
  });
  return /*#__PURE__*/React.createElement(TagWrapper, null, /*#__PURE__*/React.createElement(Button, _extends({
    className: classNames({
      open: isOpen
    }),
    type: "button"
  }, getToggleButtonProps()), (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label) || /*#__PURE__*/React.createElement(Placeholder, null, "Select an option")), /*#__PURE__*/React.createElement(List, _extends({
    className: classNames({
      open: isOpen
    })
  }, getMenuProps()), ITEMS.map((item, index) => /*#__PURE__*/React.createElement(ListItem, _extends({
    className: classNames({
      active: highlightedIndex === index,
      selected: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label) === item.label,
      isOpen: true
    }),
    key: `${item.identifier}${index}`
  }, getItemProps({
    item,
    index
  })), item.label))));
}

export default TagSelect;
const TagWrapper = styled.div.withConfig({
  displayName: "tag-select__TagWrapper",
  componentId: "sc-1rktk4l-0"
})(["position:relative;"]);
const Button = styled.button.withConfig({
  displayName: "tag-select__Button",
  componentId: "sc-1rktk4l-1"
})(["background:#ffffff;border-radius:4px;border:1px solid #dfdfdf;box-shadow:0px 2px 4px rgba(130,138,144,0.15);color:#828a90;margin-top:0.5em;overflow:hidden;padding:1em 2em;text-align:left;text-overflow:ellipsis;white-space:nowrap;width:100%;&.open{border-radius:4px 4px 0 0;}"]);
const List = styled.ul.withConfig({
  displayName: "tag-select__List",
  componentId: "sc-1rktk4l-2"
})(["background:#ffffff;border:1px solid #dfdfdf;box-shadow:0px 2px 4px rgba(130,138,144,0.15);display:none;list-style:none;margin:0;padding:0;position:absolute;top:100%;width:100%;z-index:1;&.open{display:block;}"]);
const ListItem = styled.li.withConfig({
  displayName: "tag-select__ListItem",
  componentId: "sc-1rktk4l-3"
})(["padding:1em 2em;&.active,&[aria-selected='true'],&:hover{background-color:rgba(0,0,0,0.03);}&.selected{font-weight:700;display:none;}"]);
const Placeholder = styled.span.withConfig({
  displayName: "tag-select__Placeholder",
  componentId: "sc-1rktk4l-4"
})(["color:#828a90;font-style:italic;opacity:0.4;"]);